import { render, staticRenderFns } from "./AssignAgentModal.vue?vue&type=template&id=6061868e&scoped=true&"
import script from "./AssignAgentModal.vue?vue&type=script&lang=js&"
export * from "./AssignAgentModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignAgentModal.vue?vue&type=style&index=0&id=6061868e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061868e",
  null
  
)

export default component.exports